(function($) {
    $(document).ready(function() {
        // SET COOKIE CURRENCY =====================================================================================
        var currencyCookie = $.cookie('currency');
        if (currencyCookie == undefined) {
            if (typeof Currency !== 'undefined') {
                Currency.cookie.write(theme.shopCurrency);
            }
        }
        // CURRENCY SELECTOR ========================================================================================
        if (typeof theme.shopCurrency != 'undefined') {
            var shopCurrency = theme.shopCurrency;
            // Sometimes merchants change their shop currency, let's tell our JavaScript file
            Currency.money_with_currency_format[shopCurrency] = theme.moneyFormatCurrency;
            Currency.money_format[shopCurrency] = theme.moneyFormat;
            // Cookie currency
            var cookieCurrency = Currency.cookie.read();
            // Saving the current price
            $('span.money').each(function() {
                $(this).attr('data-currency-' + theme.shopCurrency, $(this).html());
            });

            // CHANGE CONTROLL ELEMENT DESKTOP/MOBILE
            if ($(window).width() > 991) {
                var currencyActive = $('#currency_active');
                var currencySelector = $('#currency_selector');
                var currencySelectorItem = $('.currency_selector__item');
                currencySelectorItem.on('click', function(e) {
                    var newCurrency = $(this).data('value');
                    Currency.convertAll(Currency.currentCurrency, newCurrency, 'span.money', 'money_format');
                    currencyActive.text(newCurrency);
                    currencyActive.removeClass('opened');
                    currencySelector.removeClass('opened');
                });
                currencySelectorItem.each(function() {
                    var currencyValue = $(this).data('value');
                    if (currencyValue == cookieCurrency) {
                        currencyActive.text(currencyValue);
                    };
                });
                currencyActive.on('click', function() {
                    if (currencyActive.hasClass('opened')) {
                        currencyActive.removeClass('opened');
                        currencySelector.removeClass('opened');
                    } else {
                        currencyActive.addClass('opened');
                        currencySelector.addClass('opened');
                    };
                });
                $(document).on('click', function() {
                    if (currencyActive.hasClass('opened')) {
                        currencyActive.removeClass('opened');
                        currencySelector.removeClass('opened');
                    }
                });
                currencyActive.on('click', function(e) {
                    e.stopPropagation();
                });
                // If there's no cookie.
                if (cookieCurrency == null) {
                    Currency.currentCurrency = shopCurrency;
                }
                // If the cookie value does not correspond to any value in the currency dropdown.
                else if ($('#currency_selector li[data-value=' + cookieCurrency + ']').length === 0) {
                    Currency.currentCurrency = shopCurrency;
                    Currency.cookie.write(shopCurrency);
                } else if (cookieCurrency === shopCurrency) {
                    Currency.currentCurrency = shopCurrency;
                } else {
                    Currency.convertAll(shopCurrency, cookieCurrency, 'span.money', 'money_format');
                };
            } else {
                var currencySelectorItem = $('.menu_currency_selector__item');
                currencySelectorItem.on('click', function(e) {
                    var newCurrency = $(this).val();
                    Currency.convertAll(Currency.currentCurrency, newCurrency, 'span.money', 'money_format');
                    $(this).parent().addClass('current').siblings().removeClass('current');
                    Currency.cookie.write(newCurrency);
                });
                currencySelectorItem.each(function() {
                    var currencyValue = $(this).val();
                    if (currencyValue == cookieCurrency) {
                        $(this).parent().addClass('current').siblings().removeClass('current');
                    };
                });
                // If there's no cookie.
                if (cookieCurrency == null) {
                    Currency.currentCurrency = shopCurrency;
                } else if (cookieCurrency === shopCurrency) {
                    Currency.currentCurrency = shopCurrency;
                } else {
                    Currency.convertAll(shopCurrency, cookieCurrency, 'span.money', 'money_format');
                };
            }
        };

// // MEGAMENU 
        function megamenuToggle() {
            console.log('megamenuToggle() called. Window width:', $(window).width());

            if ($(window).width() > 1024) {
                // --- DESKTOP LOGIC ---
                console.log('Desktop mode activated.');
                let currentSubmenuId = null;

                // 1. Add Desktop Handlers
                $(document).off('click', '.no-redirect').on('click', '.no-redirect', function(e) {
                    e.preventDefault();
                    const $item = $(this);
                    const submenuId = $item.find('.megamenu_trigger').data('submenu');
                    
                    if (currentSubmenuId === submenuId) {
                        $('.mega-menu-container').removeClass('show');
                        currentSubmenuId = null;
                    } else {
                        $('.mega-menu-container').removeClass('show').css('display', 'none');
                        $('#' + submenuId).css('display', 'block').addClass('show');
                        currentSubmenuId = submenuId;
                    }
                });

                $(document).off('click', '.level_2__item').on('click', '.level_2__item', function(e) {
                    const $item = $(this);
                    const submenuId = $item.find('.level_2__link').data('submenu');

                    // Only items with subcategories toggle a panel; plain links navigate normally
                    if (submenuId) {
                        e.preventDefault();
                        const $currentSubcategoryGroup = $('#' + submenuId);
                        const isCurrentlyActive = $currentSubcategoryGroup.hasClass('show');

                        $('.subcategory-group').removeClass('show');
                        $('.level_2__item').removeClass('active');

                        if (!isCurrentlyActive) {
                            $currentSubcategoryGroup.addClass('show');
                            $item.addClass('active');
                        }
                    }
                });

                $(document).off('click.desktopMenu').on('click.desktopMenu', function(e) {
                    if (!$(e.target).closest('.level_1__item').length && !$(e.target).closest('.mega-menu').length) {
                        $('.mega-menu-container').removeClass('show').css('display', 'none');
                        currentSubmenuId = null;
                    }
                });

                // 2. REMOVE Mobile Handlers
                $('#megamenu_mobile_toggle').off('click');
                $('#megamenu_mobile_container .no-redirect').off('click');
                $('#megamenu_mobile_container .level_2__link').off('click');
                $(document).off('click', '.mm-back-btn');
                
                // Also ensure mobile menu is hidden
                $('#megamenu_mobile_container').removeClass('show');
                $('html, body').css({ 'overflow': 'auto' });


            } else {
                // --- START NEW MOBILE LOGIC ---
                console.log('Mobile mode activated.');
                
                const $mainContainer = $('#megamenu_mobile_container');
                const $level1Panel = $('#megamenu_mobile_ul');
                
                // One-time setup: Find all sub-panels, MOVE them, and inject headers
                if (!$mainContainer.hasClass('mm-panels-initialized')) {
                    console.log('Initializing mobile menu panels...');
                    
                    // --- Inject L2 Headers & Find Panels ---
                    $level1Panel.find('.level_1__link.no-redirect').each(function() {
                        const $link = $(this);
                        const $parentItem = $link.closest('.level_1__item');
                        const title = $link.clone().children().remove().end().text().trim();
                        const $targetPanel = $parentItem.find('.left-panel');
                        
                        if ($targetPanel.length) {
                            const panelId = 'mm-panel-' + Math.random().toString(36).substr(2, 9);
                            $targetPanel.attr('id', panelId);
                            $link.attr('data-target-panel', panelId);
                            
                            // *** Give the panel a data-parent attribute ***
                            $targetPanel.attr('data-parent-panel', $level1Panel.attr('id'));

                            $targetPanel.prepend(`
                                <div class="mm-panel-header">
                                    <span class="mm-back-btn">&lt; Back</span>
                                    <h3 class="mm-panel-title">${title}</h3>
                                </div>
                            `);
                            
                            $targetPanel.addClass('mm-panel').appendTo($mainContainer);
                        }
                    });

                    console.log('--- STARTING L3 SETUP ---');
                    $mainContainer.find('.level_2__link[data-submenu]').each(function() {
                        const $link = $(this);
                        const title = $link.text().trim();
                        const targetPanelId = $link.data('submenu');
                        
                        // FIX: Search globally or in the main container, because the parent L2 panel 
                        // was ALREADY moved out of $level1Panel in the previous step.
                        const $targetPanel = $('#' + targetPanelId); 
                        
                        if ($targetPanel.length) {
                            console.log(`L3 SETUP: Success for "${title}". Found target panel #${targetPanelId}.`);
                            $link.attr('data-target-panel', targetPanelId);
                            
                            const $parentPanel = $link.closest('.mm-panel');
                            $targetPanel.attr('data-parent-panel', $parentPanel.attr('id'));

                            // Only prepend header if it hasn't been added yet
                            if ($targetPanel.find('.mm-panel-header').length === 0) {
                                $targetPanel.prepend(`
                                    <div class="mm-panel-header">
                                        <span class="mm-back-btn">&lt; Back</span>
                                        <h3 class="mm-panel-title">${title}</h3>
                                    </div>
                                `);
                            }
                            
                            $targetPanel.addClass('mm-panel').appendTo($mainContainer);
                        } else {
                            console.error(`L3 SETUP: FAILED for "${title}". Could not find target panel #${targetPanelId}.`);
                        }
                    });
                    console.log('--- FINISHED L3 SETUP ---');
                    
                    $mainContainer.addClass('mm-panels-initialized');


                } // End one-time setup

                // --- Main Menu Toggle (Burger/X) ---
                $('#megamenu_mobile_toggle').off('click').on('click', function() {
                    const $toggle = $(this);
                    
                    if ($toggle.hasClass('is-open')) {
                        // CLOSE MENU
                        console.log('Mobile toggle clicked. Closing menu.');
                        $toggle.removeClass('is-open');
                        $mainContainer.removeClass('show');
                        $('html, body').css({ 'overflow': 'auto' });

                        setTimeout(() => {
                            $level1Panel.removeClass('is-sliding-left');
    $mainContainer.find('.mm-panel').removeClass('is-active is-sliding-left');
                        }, 300); 

                    } else {
                        // OPEN MENU
                        console.log('Mobile toggle clicked. Opening menu.');
                        $toggle.addClass('is-open');
                        $mainContainer.addClass('show');
                        $('html, body').css({ 'overflow': 'hidden' });
                    }
                });

                // --- Panel Navigation Click (L1 -> L2 and L2 -> L3) ---
                // $mainContainer.find('.level_1__link[data-target-panel], .level_2__link[data-target-panel]').off('click').on('click', function(e) {
                //     e.preventDefault();
                //     const $link = $(this);
                //     const targetPanelId = $link.attr('data-target-panel');
                //     const $targetPanel = $('#' + targetPanelId);
                    
                //     if ($targetPanel.length) {
                //         console.log('Opening panel:', targetPanelId);
                //         const $currentPanel = $link.closest('.mm-panel, #megamenu_mobile_ul');
                //         $currentPanel.addClass('is-sliding-left');
                //         $targetPanel.addClass('is-active');
                //     }
                // });

                // --- Panel Navigation Click (L1 -> L2 and L2 -> L3) ---
                console.log('Attaching panel click handler...');
                $mainContainer
                    .off('click.panelnav') // Use a namespace to be safe
                    .on('click.panelnav', '.level_1__link[data-target-panel], .level_2__link[data-target-panel]', function(e) {
                        
                        console.log('--- PANEL CLICK FIRED! ---');
                        e.preventDefault();
                        
                        const $link = $(this);
                        const targetPanelId = $link.attr('data-target-panel');
                        const $targetPanel = $('#' + targetPanelId);
                        
                        console.log('Clicked link:', $link.text().trim());
                        console.log('Target panel ID:', targetPanelId);

                        if ($targetPanel.length) {
                            console.log('Target panel was found. Sliding...');
                            const $currentPanel = $link.closest('.mm-panel, #megamenu_mobile_ul');
                            $currentPanel.addClass('is-sliding-left');
                            $targetPanel.addClass('is-active');
                        } else {
                            console.error('Target panel was NOT found.');
                        }
                    });

                // --- *** "Back" Button Click (NEW LOGIC) *** ---
                $(document).off('click', '.mm-back-btn').on('click', '.mm-back-btn', function() {
                    console.log('Back button clicked.');
                    
                    // 1. Find the panel this back button is in (the one we want to close)
                    const $currentPanel = $(this).closest('.mm-panel.is-active');
                    
                    // 2. Get the ID of the parent panel from the data attribute
                    const parentPanelId = $currentPanel.attr('data-parent-panel');
                    
                    // 3. Find the parent panel by its ID
                    const $parentPanel = $('#' + parentPanelId);
                    
                    // 4. Slide current panel right (out)
                    $currentPanel.removeClass('is-active');
                    
                    // 5. Slide parent panel right (in)
                    $parentPanel.removeClass('is-sliding-left');
                });

                // 4. REMOVE Desktop Handlers
                $(document).off('click', '.no-redirect');
                $(document).off('click', '.level_2__item');
                $(document).off('click.desktopMenu');
                
                $('.mega-menu-container').removeClass('show').css('display', 'none');
            }
            // --- END NEW MOBILE LOGIC ---
        }

		function cloneMenuForMobile() {
			console.log('cloneMenuForMobile() called.');

			const $desktopMenu = $('#megamenu_desktop_ul');
			const $mobileMenuContainer = $('#megamenu_mobile_ul');

			if ($desktopMenu.length === 0) {
				console.error('Desktop menu (.header_row_2 .level_1) not found!');
				return;
			}

			if ($mobileMenuContainer.length === 0) {
				console.error('Mobile menu container (#megamenu_level__1) not found!');
				return;
			}

			// Clear existing mobile menu items (except the first child, which contains the logo and close button)
			$mobileMenuContainer.find('.level_1__item:not(:first-child)').remove();

			// Clone each desktop menu item to mobile
			$desktopMenu.find('.level_1__item').each(function() {
				const $item = $(this).clone();
				$mobileMenuContainer.append($item);
				console.log('Cloned menu item:', $(this).find('.level_1__link').text());
			});

			// Remove desktop-only elements from mobile menu
			$mobileMenuContainer.find('.desktop-only').remove();
			console.log('Mobile menu updated.');
		}


		// Initialize
		$(document).ready(function() {
			console.log('Document ready. Initializing mega menu...');
			cloneMenuForMobile();
			megamenuToggle();
		});

		// Reinitialize on window resize
		$(window).on('resize', function() {
			console.log('Window resized. Reinitializing mega menu...');
			megamenuToggle();
		});

        // WATCH MENU DROP SIDE
        function turnMenuDropdownSide() {
            $('#megamenu .level_2__small').each(function(i) {
                if (($(this).offset().left + 470) > $(window).width()) {
                    $(this).find('.droped_linklist').addClass('left_side');
                }
            });
        };

        // STICKY MENU
        function stickyHeader() {
            var target = $('#page_header');
            var pseudo = $('#pseudo_sticky_block');
            var stick_class = 'megamenu_stuck';
            $(window).on('load scroll resize', function() {
                if ($(window).width() > 991) {
                    var scrolledValue = parseInt($(window).scrollTop());
                    var offsetValue = parseInt(pseudo.offset().top);
                    var headHeight = target.outerHeight();
                    if (scrolledValue > offsetValue) {
                        target.addClass(stick_class);
                        pseudo.css({ 'height': headHeight });
                    } else {
                        target.removeClass(stick_class);
                        pseudo.css({ 'height': 0 });
                    };
                } else {
                    target.removeClass(stick_class);
                    pseudo.css({ 'height': 0 });
                };
            });
            $(window).on('load', function() {
                setTimeout(
                    function() {
                        $(window).trigger('scroll')
                    }, 180);
            });
        };

        stickyHeader();

        // SEARCH TOGGLE
        var headerSearchForm = $('header .search_form_wrap');
        $('.search_toggle').on('click', function(e) {
            if (headerSearchForm.hasClass('open')) {
                headerSearchForm.removeClass('open');
                $(this).removeClass('open');
            } else {
                headerSearchForm.addClass('open');
                $(this).addClass('open');
            }
        });
        $('header .search_form_wrap .search_form_cover').on('click', function(e) {
            if (headerSearchForm.hasClass('open')) {
                headerSearchForm.removeClass('open');
                $('.search_toggle').removeClass('open');
                $('#search_result_container').removeClass('active').html('');
            };
        });
        $('.search_form_close').on('click', function(e) {
            headerSearchForm.removeClass('open');
            $('.search_toggle').removeClass('open');
            $('#search_result_container').removeClass('active').html('');
        });

        // AJAX SEARCH
        if (theme.searchAjaxOn) {
            var container = $('#search_result_container');
            var url = '/search?q=';
            $('.header_search input[type=search]').on('keyup', function(e) {
                var inputVal = $(this).val();
                if (inputVal.length > 2) {
                    container.addClass('active');
                    container.load(url + inputVal + ' #hidden_search_result> *', function() {
                        var list = container.find('ul');
                        if (parseInt(list.data('count_result')) > 10) {
                            list.append('<li class="centred"><a href="' + url + inputVal + '">' + list.data('caption') + ': ' + list.data('count_result') + '</a></li>');
                        }
                    });
                }
            });
        };

        $(document).on('click', '.linklist_menu_title', function() {
            if ($(window).width() <= 1024) { // For screens 768px wide or smaller
                const $listLinks = $(this).parents('.footer_item__links').find('.list_links');
                const $icon = $(this).find('.accordion-icon');

                // Toggle the active class on the menu
                $listLinks.toggleClass('active');

                // Toggle the icon
                if ($listLinks.hasClass('active')) {
                    $icon.text('-'); // Change to minus
                } else {
                    $icon.text('+'); // Change back to plus
                }
            }
        });

        // FOOTER NEWSLETTER FORM
        $('.footer_newsletter_form').each(function() {
            $(this).on('submit', function(e) {
                var formCookie = $(this).attr('class');
                $.cookie('footerformSended', formCookie);
            });
        });

        if (document.location.href.indexOf('?customer_posted=true') > 0 && $.cookie('footerformSended') == 'footer_newsletter_form') {
            $('.footer_newsletter_form .form_wrapper').hide();
            $('.footer_newsletter_form .alert-success').show();
        }
    });
})(jQuery);